export function youtubeFormatter(url: string) {
  const videoIdMatch = url.match(/v=([^&]+)/);
  if (!videoIdMatch) return url;

  const videoId = videoIdMatch[1];
  return `https://www.youtube.com/embed/${videoId}?si=XSSPidgUERyOXGIg`;
}
